import React from 'react';
type ResumeEntry = {
  dates: string;
  title: string;
  organization: string;
  bullets: string[];
};
const educationAndCertifications: ResumeEntry[] = [{
  dates: '2026 — Present',
  title: 'Paralegal Training Program',
  organization: 'UCLA Extension',
  bullets: ['Coursework includes civil litigation, contract law, legal research and writing, and professional ethics.']
}, {
  dates: '2025',
  title: 'Google Certificate in Data Analytics',
  organization: 'Google / Coursera',
  bullets: ['Completed training in SQL, R, spreadsheets, and data visualization.']
}, {
  dates: '2025',
  title: 'Bachelor of Arts in Economics',
  organization: 'San Jose State University',
  bullets: []
}];
const professionalExperience: ResumeEntry[] = [{
  dates: '2024 — 2025',
  title: 'Data Analyst',
  organization: '77Labs',
  bullets: ['Translated raw data into clear insights for the team.', 'Worked through complex problems methodically and with close attention to detail.']
}, {
  dates: 'Mar 2022 — Jul 2023',
  title: 'Golf Operations Associate',
  organization: 'Menlo Country Club',
  bullets: ['Worked with coworkers to complete daily tasks and keep operations running smoothly.', 'Delivered excellent customer service and responded quickly to member needs.']
}, {
  dates: 'Jul 2020 — Feb 2022',
  title: 'Outside Services Attendant',
  organization: 'San Jose Country Club',
  bullets: ['Managed multiple tasks while remaining adaptable and flexible in a busy operation.', 'Provided efficient, courteous service and coordinated tasks to support timely completion.']
}, {
  dates: 'Jan 2019 — Jun 2020',
  title: 'Hospitality Team Member',
  organization: 'The Source',
  bullets: ['Prepared food items according to recipes and specifications.', 'Supported front and back of house by serving customers, sanitizing work areas, and collaborating with the team.']
}];
const coreSkills = ['Legal research & writing', 'Civil litigation coursework', 'Contract law coursework', 'Data analysis & visualization', 'SQL, R & spreadsheets', 'Client service & communication', 'Attention to detail', 'Team collaboration'];
interface ResumeEntryListProps {
  entries: ResumeEntry[];
}
function ResumeEntryList({
  entries
}: ResumeEntryListProps) {
  return <div className="print-resume__entries" data-id="element-99">
      {entries.map(entry => <article className="print-resume__entry" key={`${entry.dates}-${entry.title}`} data-id="element-100">
          <div className="print-resume__entry-header" data-id="element-101">
            <div data-id="element-102">
              <h3 data-id="element-103">{entry.title}</h3>
              <p data-id="element-104">{entry.organization}</p>
            </div>
            <time data-id="element-105">{entry.dates}</time>
          </div>
          {entry.bullets.length > 0 && <ul data-id="element-106">
              {entry.bullets.map(bullet => <li key={bullet} data-id="element-107">{bullet}</li>)}
            </ul>}
        </article>)}
    </div>;
}
export function PrintableCV() {
  return <article className="print-cv print-resume" aria-hidden="true" data-id="element-108">
      <header className="print-resume__header" data-id="element-109">
        <h1 data-id="element-110">Jacob Palkin</h1>
        <p data-id="element-111">Aspiring Legal Professional · UCLA Paralegal Training Program</p>
        <a href="mailto:jacobpalkin@gmail.com" data-id="element-112">jacobpalkin@gmail.com</a>
      </header>

      <section className="print-resume__section" data-id="element-113">
        <h2 data-id="element-114">Professional Summary</h2>
        <p data-id="element-115">
          Aspiring legal professional completing the UCLA Paralegal Training
          Program, with a B.A. in Economics, data analytics training, and
          experience supporting customers and teams in fast-paced settings.
        </p>
      </section>

      <section className="print-resume__section" data-id="element-116">
        <h2 data-id="element-117">Core Skills</h2>
        <ul className="print-resume__skills" data-id="element-118">
          {coreSkills.map(skill => <li key={skill} data-id="element-119">{skill}</li>)}
        </ul>
      </section>

      <section className="print-resume__section" data-id="element-120">
        <h2 data-id="element-121">Education & Certifications</h2>
        <ResumeEntryList entries={educationAndCertifications} data-id="element-122" />
      </section>

      <section className="print-resume__section" data-id="element-123">
        <h2 data-id="element-124">Professional Experience</h2>
        <ResumeEntryList entries={professionalExperience} data-id="element-125" />
      </section>

      <footer className="print-resume__footer" data-id="element-126">
        References available upon request.
      </footer>
    </article>;
}